import { Id } from "PFCore/types";

export const bulkOperationsKeys = {
  all: () => ["bulk_operations"],
  status: (id: Id) => [...bulkOperationsKeys.all(), id, "status"],
  items: (id: Id) => [...bulkOperationsKeys.all(), id, "items"]
};
